export const statusOptions = {
    TO_WITHDRAW: {
        colorPallet: 'status',
        color: 'warning',
        icon: 'ClockIcon',
    },
    REFUND: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'ArrowCircleRightIcon',
    },
    CANCELLED: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'ArrowCircleRightIcon',
    },
    RESERVED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
    WITHDREW: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};
